function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { jsx } from "panel";
import clamp from "lodash/clamp";
import { selx } from "clsx";
import { SvgIconEl } from "common/components/svg-icon";
import { ButtonEl } from "../button";
import { ButtonSize, ButtonTheme } from "../button/constants";
import { TooltipEl } from "../tooltip";
import { InputLabelEl } from "./label";
import { InputType, ValidationStatus } from "./types";
import styles from "./index.module.styl";
function RightIcon(_ref) {
  let {
    cmp
  } = _ref;
  if (cmp.attr("hide-right-icon")) {
    return null;
  }
  const icon = {
    valid: "circle-checkmark",
    invalid: "warning"
  }[cmp.attr("validation-status")];
  if (cmp.attr("validation-status")) {
    return /* @__PURE__ */ jsx("div", { sel: selx(styles.mpInputRightIcon, {
      [styles.valid]: cmp.attr("validation-status") === "valid",
      [styles.invalid]: cmp.attr("validation-status") === "invalid"
    }) }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
      icon
    } }));
  } else if (cmp.attr("always-show-clear") || cmp.state.value && cmp.attr("show-clear")) {
    return /* @__PURE__ */ jsx("div", { sel: selx(styles.mpInputRightIcon, styles.clickable), on: {
      click: cmp.helpers.handleClearInput
    } }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
      icon: "circle-clear"
    }, sel: selx(styles.mpInputClickableIcon) }));
  } else if (cmp.attr("pre-text") && cmp.attr("help-text")) {
    return /* @__PURE__ */ jsx("div", { sel: selx(styles.mpInputRightIcon) }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
      icon: "info-xs"
    } }), /* @__PURE__ */ jsx(TooltipEl, { attrs: {
      text: cmp.attr("help-text")
    } }));
  }
  return null;
}
function NumericControls(_ref2) {
  let {
    cmp
  } = _ref2;
  return /* @__PURE__ */ jsx("div", { sel: selx(styles.mpInputNumericArrowControls), "data-sentry-component": "NumericControls", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(ButtonEl, { sel: selx(styles.numericArrowButton), attrs: {
    theme: ButtonTheme.Tertiary,
    size: ButtonSize.Tiny,
    icon: "caret-up"
  }, on: {
    mousedown: (ev) => {
      ev.preventDefault();
      cmp.update({
        value: String(clamp(parseInt(cmp.state.value, 10) + 1, parseInt(cmp.attr("min"), 10), parseInt(cmp.attr("max"), 10)))
      });
      cmp.debouncedChange();
    }
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx(ButtonEl, { sel: selx(styles.numericArrowButton), attrs: {
    theme: ButtonTheme.Tertiary,
    size: ButtonSize.Tiny,
    icon: "caret-down"
  }, on: {
    mousedown: (ev) => {
      ev.preventDefault();
      cmp.update({
        value: String(clamp(parseInt(cmp.state.value, 10) - 1, parseInt(cmp.attr("min"), 10), parseInt(cmp.attr("max"), 10)))
      });
      cmp.debouncedChange();
    }
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }));
}
export function template() {
  const {
    value
  } = this.state;
  const validationStatus = this.attr("validation-status");
  const isValid = validationStatus === ValidationStatus.Valid;
  const isInvalid = validationStatus === ValidationStatus.Invalid;
  return /* @__PURE__ */ jsx("div", { sel: selx(styles.mpInputContainer, {
    [styles.themeWhite]: this.attr("theme") === "white"
  }), "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, this.attr("label") ? /* @__PURE__ */ jsx(InputLabelEl, { sel: selx(styles.inputLabel), attrs: {
    label: this.attr("label"),
    "field-id": this.attr("field-id"),
    necessary: this.attr("necessary"),
    "help-text": this.attr("help-text"),
    "extra-info": this.attr("extra-info")
  }, on: {
    click: () => this.attr("disabled") === false && this.focus()
  } }) : null, /* @__PURE__ */ jsx(
    "div",
    {
      sel: selx(styles.mpInputFieldContainer, {
        [styles.hasMinInputWidth]: Boolean(this.attr("min-input-width")),
        [styles.hasMultilinePrefix]: this.attr("multiline-prefix"),
        [styles.hideFocusStyling]: this.attr("hide-focus-styling"),
        [styles.isDisabled]: this.attr("disabled"),
        [styles.sizeSmall]: this.attr("size") === "small",
        [styles.sizeMedium]: this.attr("size") === "medium",
        [styles.sizeLarge]: this.attr("size") === "large",
        [styles.typeNumber]: this.attr("type") === "number",
        [styles.typePassword]: this.attr("type") === "password",
        [styles.typeText]: this.attr("type") === "text",
        [styles.isValid]: isValid
      }),
      class: {
        [styles.isInvalid]: isInvalid
      },
      on: {
        click: () => this.focus()
      }
    },
    ((_this$params$suffixRe, _this$params) => {
      const TagName = this.attr("type") === "textarea" ? "textarea" : "input";
      return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: selx(styles.mpInputLeftArea) }, this.attr("icon") && /* @__PURE__ */ jsx("div", { sel: selx("mp-input-left-icon") }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
        icon: this.attr("icon")
      }, sel: selx(styles.mpInputLeftIcon) })), this.attr("pre-text") && /* @__PURE__ */ jsx("div", { sel: selx(styles.mpInputPreText, {
        [styles.sizeSmall]: this.attr("size") === "small",
        [styles.sizeMedium]: this.attr("size") === "medium",
        [styles.sizeLarge]: this.attr("size") === "large"
      }), on: {
        click: () => this.focus()
      } }, this.attr("pre-text"))), /* @__PURE__ */ jsx("div", { sel: selx(styles.mpInputWrapper), hook: {
        insert: (_ref3) => {
          let {
            elm
          } = _ref3;
          return this.handleInputWrapperInsert(elm);
        }
      } }, this.params.prefixRenderer && (this.attr("multiline-prefix") ? this.params.prefixRenderer() : /* @__PURE__ */ jsx("div", { hook: {
        insert: (_ref4) => {
          let {
            elm
          } = _ref4;
          return this.handleInputPrefixInsert(elm);
        }
      } }, this.params.prefixRenderer())), /* @__PURE__ */ jsx(TagName, { sel: selx(styles.mpInput), style: _objectSpread(_objectSpread({
        "text-align": this.attr("text-align")
      }, this.attr("min-input-width") && {
        "min-width": "".concat(this.attr("min-input-width"), "px")
      }), this.attr("multiline-prefix") && {
        width: this.state.textWidth ? "".concat(this.state.textWidth, "px") : "auto"
      }), attrs: _objectSpread(_objectSpread({}, this.attr("ariaLabel") ? {
        ["aria-label"]: this.attr("ariaLabel")
      } : {}), {}, {
        autocomplete: this.attr("autocomplete"),
        elref: "inputTag",
        id: this.attr("field-id"),
        name: this.attr("field-name"),
        placeholder: this.attr("placeholder"),
        disabled: this.attr("disabled"),
        readonly: this.attr("readonly"),
        size: 1,
        // We do custom comma formatting on number type inputs.
        // Browsers won't accept something like '1,000' as a valid
        // do do not use the "type" attribute in this case.
        type: TagName === "input" && this.attr("type") !== InputType.Number ? this.attr("type") : null,
        maxlength: this.attr("maxlength"),
        minlength: TagName === "input" ? this.attr("min") : null,
        min: this.helpers.supportsMinMaxAttrs() ? this.attr("min") : null,
        // only enforces arrow key decrements
        max: this.helpers.supportsMinMaxAttrs() ? this.attr("max") : null,
        // only enforces arrow key increments
        step: this.helpers.supportsMinMaxAttrs() ? this.attr("step") : null,
        // only enforces arrow key increments
        "not-focusable": this.attr("not-focusable")
      }), props: {
        value: this.displayValue
      }, on: {
        input: this.helpers.handleInput,
        blur: this.helpers.handleBlur,
        focus: this.helpers.handleFocus,
        change: this.helpers.handleChange
      }, hook: {
        insert: (_ref5) => {
          let {
            elm
          } = _ref5;
          this.handleSearchInputInsert(elm);
        }
      } })), /* @__PURE__ */ jsx("div", { sel: selx(styles.mpInputRightArea) }, (_this$params$suffixRe = (_this$params = this.params).suffixRenderer) === null || _this$params$suffixRe === void 0 ? void 0 : _this$params$suffixRe.call(_this$params), this.attr("action-text") && value ? /* @__PURE__ */ jsx("div", { sel: selx(styles.mpInputActionText) }, this.attr("action-text")) : null, this.attr("type") === InputType.Number && this.attr("show-numeric-input-controls") && /* @__PURE__ */ jsx(NumericControls, { cmp: this }), /* @__PURE__ */ jsx(RightIcon, { cmp: this })));
    })()
  ), this.attr("validation-status") === "invalid" && this.attr("error-message") ? /* @__PURE__ */ jsx("div", { attrs: {
    elref: "inputErrorMessage"
  }, sel: selx(styles.mpInputErrorMessage) }, this.attr("error-message")) : null);
}
